export { ProductLogo } from './product-logo';
